import { usePaymentFormContext } from '../context/PaymentFormContext';
export const useTermsOfServiceDisplay = () => {
  const {
    checkoutSession
  } = usePaymentFormContext();
  const checkoutSessionJS = checkoutSession.toJS();
  const policySettings = checkoutSessionJS.policySettingsData;
  const consentCheckboxInfo = checkoutSessionJS.consentCheckboxInfo;
  const {
    collectPaymentMethodOnFile
  } = checkoutSessionJS;
  const customPolicyEnabled = policySettings === null || policySettings === void 0 ? void 0 : policySettings.customPolicyEnabled;
  const shouldShowClickToCancelCheckbox = (consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isClickToCancelCheckboxRequired) || false;
  const shouldShowTermsOfServiceAcknowledgementCheckbox = (consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isTermsOfServiceCheckboxRequired) || false;
  const shouldDisplayPMOFCheckbox = (consentCheckboxInfo === null || consentCheckboxInfo === void 0 ? void 0 : consentCheckboxInfo.isPaymentMethodOnFileCheckboxRequired) || false;

  // only display PMOF as a message if PMOF is on and terms of service is off
  const shouldDisplayPMOFMessage = collectPaymentMethodOnFile && !shouldDisplayPMOFCheckbox && !customPolicyEnabled;
  const shouldShowClickToCancelMessage = shouldShowClickToCancelCheckbox && !shouldShowTermsOfServiceAcknowledgementCheckbox;
  const shouldShowTermsOfServiceInputs = shouldShowTermsOfServiceAcknowledgementCheckbox || shouldDisplayPMOFCheckbox || shouldShowClickToCancelCheckbox;
  const shouldShowTermsOfServiceMessages = Boolean(!shouldShowTermsOfServiceAcknowledgementCheckbox && customPolicyEnabled && ((policySettings === null || policySettings === void 0 ? void 0 : policySettings.termsOfServiceUrl) || (policySettings === null || policySettings === void 0 ? void 0 : policySettings.cancellationPolicyText) || (policySettings === null || policySettings === void 0 ? void 0 : policySettings.refundPolicyText)) || shouldDisplayPMOFMessage || shouldShowClickToCancelMessage);
  return {
    shouldShowTermsOfServiceInputs,
    shouldShowTermsOfServiceMessages,
    shouldShowTermsOfServiceAcknowledgementCheckbox,
    shouldShowClickToCancelCheckbox,
    shouldDisplayPMOFCheckbox,
    shouldDisplayPMOFMessage
  };
};